import { DataLayer } from "@sazka/utils/data-layer";
import { Analytics } from "./analytics";

export function analyticsCollectorTicketClick() {
    document.querySelectorAll(".product-card--fun").forEach((card, index) => {
        const position = (environment.relativeUrl === "/" ? "home." : "") + "bonus." + index;
        const text =
            card.querySelector(".product-card__title").textContent +
            " " +
            card.querySelector(".product-card__desc").textContent;
        const id = card.id;

        const promo = {
            id: id,
            name: id,
            creative: text,
            position: position,
        };
        actionImpressPromo(promo);
        card.addEventListener("click", () => actionClickBonus(promo));
    });

    if (Analytics.vertical !== "elosy" && Analytics.vertical !== "losy") {
        return;
    }

    $(document).on("click", ".product-card", (e) => {
        const card = $(e.currentTarget);
        const price = parseInt(card.find(".card-tag .amount").text());
        const list = getTicketList(card);
        const position = card.hasClass("flipster__item")
            ? card.prevAll(":not(.no-results-card)").length
            : card.parent().prevAll(":not(.hide)").length;

        pushTicketClick(card.data("game-code"), price, position, list);
    });
}

function getTicketList(e: JQuery) {
    const root = e.closest("[data-a-list]");
    if (root.length) {
        return root.data("a-list");
    } else {
        const activeFilterTab = $(".filter__nav__item:not(.collapsed)");
        return activeFilterTab.attr("href") != "#ticket-filter-price" ? "byGroup" : "byPrice";
    }
}

function pushTicketClick(
    gameCode: string,
    price: number,
    position: number,
    list: "mostPlayed" | "news" | "byPrice" | "byGroup" | "helper"
) {
    const product = {
        fullPrice: price,
        pocketPrice: price,
        price: price,
        tax: 0,
        gameCode: gameCode,
        list: `${Analytics.vertical}.${list}`,
        position: position,
        verticalCode: Analytics.vertical,
    };

    actionShowProducts(product);
}

function actionShowProducts(product) {
    DataLayer.pushInstant({
        event: "action.show.products",
        action: {
            show: {
                products: [product],
            },
        },
    });
}

function actionImpressPromo(promo) {
    DataLayer.push({
        event: "action.impress.promos",
        action: {
            impress: {
                promos: [promo],
            },
        },
    });
}

function actionClickBonus(promo) {
    DataLayer.pushInstant({
        event: "action.show.promos",
        action: {
            show: {
                promos: [promo],
            },
        },
    });
}
